import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';


export default function IconEmail({className, height, title}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M3 4.5H17C17.2761 4.5 17.5 4.72386 17.5 5V7.2181L10.6338 11.2571C10.2426 11.4872 9.75741 11.4872 9.36623
      11.2571L2.5 7.2181V5C2.5 4.72386 2.72386 4.5 3 4.5ZM2.5 8.95837V15C2.5 15.2761 2.72386 15.5 3 15.5H17C17.2761 15.5
      17.5 15.2761 17.5 15V8.95837L11.3943 12.55C10.5337 13.0562 9.4663 13.0562 8.6057 12.55L2.5 8.95837ZM1 5C1 3.89543
      1.89543 3 3 3H17C18.1046 3 19 3.89543 19 5V15C19 16.1046 18.1046 17 17 17H3C1.89543 17 1 16.1046 1 15V5Z
    </Icon>
  );
}
